// src/mocks/handlers/auth.handlers.js
import { DEMO_TOKEN, DEMO_REFRESH_TOKEN, DEMO_USER } from '../data/user.demo';

export const login = async () => ({
    success: true,
    accessToken: DEMO_TOKEN,
    refreshToken: DEMO_REFRESH_TOKEN,
    user: DEMO_USER,
});

export const refresh = async () => ({
    success: true,
    accessToken: DEMO_TOKEN,
    refreshToken: DEMO_REFRESH_TOKEN,
});
